import gql from 'graphql-tag'

const createAzione = gql`
  mutation createAzione($azione: CreateAzione!) {
    createAzione(azione: $azione) {
      id
      utenteId
      utente {
        id
        nome
      }
      clienteId
      cliente {
        id
        nome
      }
      offertaId
      offerta {
        id
        nome
      }
      campagnaId
      campagna {
        id
        nome
      }
      tipoAzioneId
      tipoAzione {
        id
        tipo
      }
      appuntamentoAgenteId
      appuntamentoAgente {
        id
        nome
      }
      dataOra
      descrizione
      appuntamentoDaDataOra
      appuntamentoADataOra
      appuntamentoLuogo
      appuntamentoStato
      appuntamentoOrigine
      promemoriaUtenteId
        promemoriaUtente {
          id
          nome
          ruolo
        }
        promemoriaDataOra
        promemoriaDismesso
      votoAgente
      flagSondaggioInviato
      nonRisposto
    }
  }
`

export default createAzione


// WEBPACK FOOTER //
// ./src/graphql/mutations/createAzione.js